import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { commodities } from '../../mocks/commodities';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CommodityHero from './components/CommodityHero';
import CommodityOverview from './components/CommodityOverview';
import CommodityProducts from './components/CommodityProducts';
import CommodityApproach from './components/CommodityApproach';
import RelatedCommodities from './components/RelatedCommodities';

export default function ProductDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const commodity = commodities.find((c) => c.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [slug]);

  if (!commodity) {
    return (
      <div className="min-h-screen bg-[#061828] flex flex-col items-center justify-center gap-6">
        <Navbar />
        <i className="ri-error-warning-line text-[#e8a020] text-6xl" />
        <h1 className="text-white text-2xl font-bold">Commodity not found</h1>
        <p className="text-white/50 text-sm">The category you&apos;re looking for doesn&apos;t exist.</p>
        <Link
          to="/#products"
          className="mt-2 text-[#e8a020] text-sm font-bold tracking-widest uppercase flex items-center gap-2 hover:gap-3 transition-all duration-200"
        >
          <i className="ri-arrow-left-line" /> Back to Products
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <CommodityHero commodity={commodity} />
      <CommodityOverview commodity={commodity} />
      <CommodityProducts commodity={commodity} />
      <CommodityApproach commodity={commodity} />
      <RelatedCommodities current={commodity} />
      <Footer />
    </div>
  );
}
